import { Component, Input, ViewChild } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { MessageService } from 'primeng/api';
import { ColumnPreferenceService, ViewColumnConfig } from 'src/app/shared/services/column-preference.service';

@Component({
  selector: 'app-column-toggle',
  templateUrl: './column-toggle.component.html',
  styleUrls: ['./column-toggle.component.css']
})
export class ColumnToggleComponent {

  @Input() moduleName!: string;
  @Input() allowedKeys?: string[];
  @ViewChild('panel') panel!: OverlayPanel;

  // real array on the component — NOT a getter re-read from localStorage every CD cycle
  columns: ViewColumnConfig[] = [];

  constructor(
    private columnPreferenceService: ColumnPreferenceService,
    private messageService: MessageService
  ) {}

  ngOnChanges(): void {
    this.refreshColumns();
  }

  private refreshColumns(): void {
    const all = this.columnPreferenceService
      .getModuleColumns(this.moduleName)
      .map(c => ({ ...c }));

    this.columns = this.allowedKeys
      ? all.filter(c => c.locked || this.allowedKeys!.includes(c.key))
      : all;
  }

  open(event: Event): void {
    this.refreshColumns(); // pick up anything changed elsewhere before opening
    this.panel.toggle(event);
  }

  trackByKey(_index: number, col: ViewColumnConfig): string {
    return col.key;
  }

  onRowClick(col: ViewColumnConfig, event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    if (col.locked) return;

    // flip UI instantly, independent of the HTTP call
    col.visible = !col.visible;

    this.columnPreferenceService.saveColumnVisibility(this.moduleName, col).subscribe({
      error: () => {
        col.visible = !col.visible; // rollback UI on failure
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Could not update column preference'
        });
      }
    });
  }
}